
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AddButton from '../../components/common/AddButton/AddButton';
import Filter from '../../components/common/Filter/Filter';
import Sort from '../../components/common/Sort/Sort';
import AddUserRolePopup from '../../components/Popup/AddPopup/AddInternalUserRoles';
import ArchivePopup from '../../components/Popup/ArchivePopup/ArchivePopup';
import EditIcon from '../../components/Table/EditIcon/EditIcon';
import ArchiveIcon from '../../components/Table/ArchiveIcon/ArchiveIcon';
import ExportLabel from '../../components/common/ExportLabel/Export';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import DetailIcon from '../../components/Table/DetailIcon/DetailIcon';
import EditInternalUserRolesPopup from '../../components/Popup/EditPopup/EditInternalUserRoles';
import InternalUserDetailPopup from '../../components/Popup/DetailPopup/InternalUserDetail';
import '../../pages/Settings/Settings.css';
import SimpleSearchBox from '../../components/common/Search/SimpleSearch';
import { baseurl } from '../../api';
import { isRequired, isTextOnly } from '../../validation';
import { useCheckboxClick } from '../../checkboxclick';
import ArchiveSelectedItem from '../../components/common/ArchiveSelectedItemLabel/ArchiveSelectedItems';
import authenticatedAxios from '../../authenticatedAxios';
import useFilterStore from '../../store/useFilterStore';
import DeleteIcon from '../../components/Table/DeleteIcon/DeleteIcon';
import DeletePopup from '../../components/Popup/DeletePopup/DeletePopup';
import useRefreshStore from '../../store/useRefreshStore';
const pageKey = "internaluserroles"


const UserRoles = () => {
  const { setFilters, getFilters } = useFilterStore();
  const savedFilters = getFilters(pageKey);
  const [isEditPopupOpen, setIsEditPopupOpen] = useState(false);
  const [isArchivePopupOpen, setIsArchivePopupOpen] = useState(false);
  const [isNewPopupOpen, setIsNewPopupOpen] = useState(false);
  const [isDetailPopupOpen, setIsDetailPopupOpen] = useState(false); 
  const [items, setItems] = useState([]);
  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [initialTableRows, setData]=useState([]);
  const sortOptions = ['A-Z', 'Z-A', 'Newst','Oldest'];
  const filterOptions = ['Default', 'Archived', 'Unarchived'];
  const [searchParams, setSearchParams] = useState(savedFilters?.searchParams || { term: "" });
  const [selectedFilterOption, setSelectedFilterOption] = useState(savedFilters?.selectedFilterOption || "Unarchived");
  const [selectedSortOption, setSelectedSortOption] = useState(savedFilters?.selectedSortOption || "Newest");
  const [popupError, setPopupError] = useState('');
  const navigate = useNavigate()
  const { isParentSelected, selectedItems, handleParentCheckboxChange, handleChildCheckboxChange, resetCheckboxState, } = useCheckboxClick(items);
  const { refreshKeys } = useRefreshStore();
  const refreshKey = refreshKeys["Internal User roles"] || 0;
  const fetchUserroles = async (id = null, isEdit = false) => {
    try {
      let response;
      if (id) {
        // Fetch details for a specific user role if an ID is provided
        response = await authenticatedAxios.get(`${baseurl}accounts/roles/internal/?id=${id}`);
  
        if (response?.data?.response_code === 1) {
          setSelectedItem(response.data.data);
          if (isEdit) {
            setIsEditPopupOpen(true);
          } else {
            setIsDetailPopupOpen(true);
          }
        } else {
          console.error("No data found for the selected user role.");
        }
      } else {
        // Fetch user roles with search, filter, and sort
        const params = {
          search: searchParams.term,
          filter: selectedFilterOption === 'Default' ? undefined : selectedFilterOption.toLowerCase(),
          sort: mapSortOptionToQuery(selectedSortOption),
        };
  
        response = await authenticatedAxios.get(`${baseurl}accounts/roles/internal/`, { params });
        if (response?.data?.response_code === 1) {
          setItems(response.data.data);
        } else {
          console.error("Unexpected response code or no data found for user roles.");
        }
      }
    } catch (error) {
      if (error?.response?.data?.error_code === 1001) {
        navigate("/permission-denied");
      } else {
        console.error('Error fetching user roles:', error);
      }
    }
  };
  
  
useEffect(() => {
   
    fetchUserroles();
    setFilters(pageKey, {
      searchParams,
      selectedFilterOption,
      selectedSortOption,
  });
}, [searchParams, selectedFilterOption, selectedSortOption]);

  useEffect(() => {
    fetchUserroles();
  }, [refreshKey]);

  
  const fetchData = async () => {
    try {
        const response = await authenticatedAxios.get(
          `${baseurl}accounts/permissions/?is_company=false`
        );
        
        if (response.data) {
            setData(response.data); 
            
        } else {
            console.error('Error fetching data: Data is empty');
        }
    } catch (error) {
        console.error('Error fetching data:', error);
    }
};


const AddUserRole = async (formData) => {
  try {
    const response = await authenticatedAxios.post(`${baseurl}accounts/roles/internal/`, formData);

    if (response.data.response_code === 1) {
      await fetchUserroles();
      setPopupError('');
      closePopups();
    } else {
      setPopupError(response.data.message || 'Something went wrong!');
    }
  } catch (error) {
    setPopupError('Failed to add Feature. Please try again.');
  }
};

const handleDelete = async () => {
  try {
    const response = await authenticatedAxios.delete(
      `${baseurl}accounts/roles/internal/?id=${selectedItem.id}`
    );

    if (response.status >= 200 && response.status < 300) {
      setIsDeletePopupOpen(false); 
      fetchUserroles(); 
      return;
    }
    throw new Error(`Unexpected status code: ${response.status}`);
  } catch (error) {
    // console.error('Error deleting plan:', error);
  }
};

const handleSortOptionSelect = (option) => {
  setSelectedSortOption(option);
};

const handleFilterSelect = (option) => {
  setSelectedFilterOption(option);
};

const handleSearchSelect = (searchTerm) => {
  setSearchParams({ term: searchTerm });
};


const handleArchiveSelectedItems = async () => {
  try {
    const response = await authenticatedAxios.post(`${baseurl}accounts/roles/archive/`, {
      id_list: selectedItems,
    });

    if (response.status >= 200 && response.status < 300) {
      fetchUserroles();
      resetCheckboxState();
      closePopups();
    } else {
      console.error('Failed to archive/unarchive selected items.');
    }
  } catch (error) {
    console.error('Error archiving/unarchiving selected items:', error);
  }
};


const handleArchive = async () => {
  try {
    const response = await authenticatedAxios.get(
      `${baseurl}accounts/roles/archive/?id=${selectedItem.id}`
    );
    
    if (response.status >= 200 && response.status < 300) {
      await fetchUserroles(); 
      closePopups();    
    }
  } catch (error) {
  }
};

const handleEdit = async (formData) => {
  try {
      const response = await authenticatedAxios.put(`${baseurl}accounts/roles/internal/?id=${selectedItem.id}`, formData, );

      if (response.status >= 200 && response.status < 300) {
          
          await fetchUserroles();
          closePopups(); 
      } else {
          console.error('Failed to edit tax.');
      }
  } catch (error) {
     console.error('Error editing tax:', error);
  }
};

const mapSortOptionToQuery = (option) => {
    switch (option) {
      case 'A-Z':
        return 'a_to_z';
      case 'Z-A':
        return 'z_to_a';
      case 'Newest':
        return 'newest';
      case 'Oldest':
        return 'oldest';
      default:
        return 'newest';
    }
  };



  const handleEditClick = (item) => {
    fetchData();
    fetchUserroles(item.id, true); 
  };
  
  const handleDetailClick = (item) => {
    fetchUserroles(item.id, false); 
    fetchData();
  };
  
  const handleDeleteClick = async (item) => {
    setSelectedItem(item);
    setIsDeletePopupOpen(true);
  };

  const handleArchiveClick = async (item) => {
    setSelectedItem(item);
    setIsArchivePopupOpen(true);
  };


  const handleNewClick = () => {
    setSelectedItem(null);
    setIsNewPopupOpen(true);
    fetchData();
  };

  const closePopups = () => {
    setIsEditPopupOpen(false);
    setIsArchivePopupOpen(false);
    setIsNewPopupOpen(false);
    setIsDetailPopupOpen(false)
    setPopupError('');
    setSelectedItem([])
  };

  const tableHeaders = ['Permission', 'Adding', 'Editing', 'Listing', 'Archive', 'Delete'];

  // const addPopupFields = [
  //   { label: 'name', name:'name', type: 'small-input',validators: [isTextOnly], },
  // ];
  const addPopupFields = [
    { label: 'User Role', name:'name', type: 'small-input', validators: [isRequired], defaultValue: '' },
  ];
  const editPopupFields = [
    { label: 'User Role', name: 'name', type: 'small-input',
       defaultValue: selectedItem?.name || '',validators: [isRequired]
      },
  ];
  
  const detailPopupFields = [
    { label: 'User Role','name':'name',  value: selectedItem?.name, type: 'small-input' },
  ]; 

  const deletePopupFields = [
    { label: 'Are you sure you want to delete this record? Once deleted, it cannot be recovered.', type: 'text' },
  ];

  const handleExportComplete = () => {
    resetCheckboxState();
  };

  return (

    <div className='whole-container'>  
      <div className='top-heading'>
        <PageHeader pageName="Settings /" nestedpageName="Internal User Roles"  linkTo="/internal-users" /> 
        <div className='export-container'>
            <ArchiveSelectedItem
              selectedItems={selectedItems}
              items={items}
              onArchiveSelected={handleArchiveSelectedItems}
            />
          <ExportLabel
            exportUrl={`${baseurl}accounts/roles/export/`}
            selectedIds={selectedItems}
            onExportComplete={handleExportComplete}
          />
        </div>
      </div>     
      <div className='pagename-container'>
        <div className='page-name'>
          <h1 className='common-text fts-22 ftw-6 blue'>Internal User Roles</h1>
        </div>
        <div className='pagename-right-container'>
          <AddButton onClick={handleNewClick} />
          <SimpleSearchBox placeholder="Search" onSearchSelect={handleSearchSelect} defaultValue={searchParams?.term}/>
          <Filter options={filterOptions} onFilterSelect={handleFilterSelect} defaultValue={selectedFilterOption} />
          <Sort options={sortOptions} onOptionSelect={handleSortOptionSelect} defaultValue={selectedSortOption} />
        </div>
      </div>
      <div className='table-container'>
        <table className='common-table'>
          <thead className='common-table-head'>
            <tr className='common-table-thead-tr'>
              <th>
                  <input
                    className="table-selectbox table-parent-selectbox"
                    type="checkbox"
                    checked={isParentSelected}
                    onChange={handleParentCheckboxChange}
                  />Name
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody className='common-table-tbody user-roles-table-tbody'>
            {items.length > 0 ? (
              items.map((role) => (
                <tr key={role.id} className={`user-roles-table-tr ${role.is_archived ? 'archived-item' : ''}`}>                
                  <td className='user-roles-table-name'>
                    <input
                      className="table-selectbox table-child-selectbox"
                      type="checkbox"
                      checked={selectedItems.includes(role.id)}
                      onChange={() => handleChildCheckboxChange(role.id)}
                    />
                    {role.name}
                  </td>

                  <td className="actions user-roles-table-action">
                    <EditIcon onClick={() => handleEditClick(role)} />
                    <ArchiveIcon onClick={() => handleArchiveClick(role)} isArchived={role.is_archived} />
                    <DetailIcon onClick={() => handleDetailClick(role)} />
                    <DeleteIcon onClick={() => handleDeleteClick(role)} />
                  </td>
                  </tr>
              ))
            ) : (
              <tr>
                <td colSpan="2">
                  No User role found.
                </td>
              </tr>
            )}
          </tbody>


        </table>
      </div>



      <ArchivePopup
        isOpen={isArchivePopupOpen}
        isArchived={selectedItem?.is_archived}
        archivename={selectedItem?.name}
        onSave={handleArchive}
        onClose={() => setIsArchivePopupOpen(false)}
      />
      <EditInternalUserRolesPopup
        isOpen={isEditPopupOpen}
        title="Edit User Role"
        fields={editPopupFields}
        onSave={handleEdit}
        onClose={closePopups}
        tableHeaders={tableHeaders}
        initialTableRows={initialTableRows}
        selected={selectedItem}
      />
      <AddUserRolePopup 
        isOpen={isNewPopupOpen}
        title="Add Internal User Role"
        buttonName='Add User Role'
        fields={addPopupFields}  
        onSave={AddUserRole}
        onClose={closePopups}
        tableHeaders={tableHeaders}
        initialTableRows={initialTableRows}
        popupErrorMessage={popupError}
      />
      <InternalUserDetailPopup
        isOpen={isDetailPopupOpen} 
        title="User Role Details"
        details={detailPopupFields}
        onClose={closePopups}
        tableHeaders={tableHeaders}
        tableRows={initialTableRows}
        selected={selectedItem}
      />

      <DeletePopup
        isOpen={isDeletePopupOpen}
        title="Delete Recipient Group"
        fields={deletePopupFields}
        onSave={handleDelete}
        onClose={closePopups}
      />

    </div>
  );
};

export default UserRoles;
